// components
import { Typography } from '@interstate/components/Typography';

type VehicleTitleProps = {
    title: string;
};

export const VehicleTitle = ({ title }: VehicleTitleProps) => {
    return (
        <Typography variant="h5" sx={{ textTransform: 'capitalize' }}>
            {title}
        </Typography>
    );
};
